export default __webpack_public_path__ + "static/TeamIllustration-6956f2e16573f400852e18220469653d.svg";